import React, { useEffect } from 'react';
import { ProgressCircle } from '@americanexpress/dls-react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { rsvpRedirect } from '../core';

const RsvpVerification = ({ dispatch, params: { rsvpCode } }) => {
  useEffect(() => {
    dispatch(rsvpRedirect(rsvpCode));
  }, []);

  return (
    <div
      className="dls-gray-02-bg flex flex-justify-center flex-align-center"
      style={{ height: '100vh' }}
      data-testid="loading-page"
    >
      <ProgressCircle />
    </div>
  );
};

RsvpVerification.propTypes = {
  dispatch: PropTypes.func.isRequired,
  params: PropTypes.shape({
    rsvpCode: PropTypes.string.isRequired,
  }).isRequired,
};

export default connect()(RsvpVerification);
